import * as THREE from 'three';

// Loads the night stadium tools/build-stadium.mjs prepared for
// visualizers/stadium.js - the picture with everything off, the light the
// floodlights on, the lossless tower id map, the ramp masks (rect, halo, lens;
// loaded twice: linear for the soft edges, nearest for the ramp id), the softened stands
// mask, the 6 000 phone positions and the ramp data - ONCE, at startup.
// Same preload/get shape as alley-assets.js, and the same rule: the preload
// is a WIRING POINT every entry point must call (main, main-radio, play-boot,
// the capture harness), and it resolves false when anything is missing so
// the entry point can withdraw Stadium from the rotation (no fallback: the
// visualizer IS the two photographs).
//
// The id map is DATA: NearestFilter, no mipmaps, no colour space. The two
// photographs are sRGB and decoded by the GPU, so the shader adds them in
// linear light. The phones are a float data texture (x, y, row, angle per
// texel), read in the vertex shader: nothing is uploaded after this.
const MANIFEST_URL = 'textures/stadium.json';
export const PHONES_TEX_W = 128;

let _assets = null;
let _promise = null;

function loadTexture(url, configure) {
  return new Promise(function (resolve, reject) {
    new THREE.TextureLoader().load(url, function (t) { configure(t); t.needsUpdate = true; resolve(t); }, undefined, function () {
      reject(new Error(url + ' failed to load'));
    });
  });
}
function photo(t) {
  t.colorSpace = THREE.SRGBColorSpace;
  t.generateMipmaps = false;
  t.minFilter = THREE.LinearFilter;
  t.magFilter = THREE.LinearFilter;
  t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
}
function data(t) {
  t.colorSpace = THREE.NoColorSpace;
  t.generateMipmaps = false;
  t.minFilter = THREE.NearestFilter;
  t.magFilter = THREE.NearestFilter;
  t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
}
function mask(t) {
  t.colorSpace = THREE.NoColorSpace;
  t.generateMipmaps = false;
  t.minFilter = THREE.LinearFilter;
  t.magFilter = THREE.LinearFilter;
  t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
}

export function preloadStadium() {
  if (_promise) return _promise.then(function (a) { return !!a; });
  _promise = fetch(MANIFEST_URL)
    .then(function (r) {
      if (!r.ok) throw new Error('stadium.json HTTP ' + r.status);
      return r.json();
    })
    .then(function (manifest) {
      return Promise.all([
        loadTexture('textures/' + manifest.off, photo),
        loadTexture('textures/' + manifest.on, photo),
        loadTexture('textures/' + manifest.ids, data),
        loadTexture('textures/' + manifest.masks, mask),
        loadTexture('textures/' + manifest.masks, data),
        loadTexture('textures/' + manifest.stands, mask),
        fetch('textures/' + manifest.phones).then(function (r) {
          if (!r.ok) throw new Error(manifest.phones + ' HTTP ' + r.status);
          return r.arrayBuffer();
        }),
        fetch('textures/' + manifest.data).then(function (r) {
          if (!r.ok) throw new Error(manifest.data + ' HTTP ' + r.status);
          return r.json();
        })
      ]).then(function (parts) {
        const raw = new Float32Array(parts[6]);
        const count = raw.length / 4;
        const h = Math.ceil(count / PHONES_TEX_W);
        const buf = new Float32Array(PHONES_TEX_W * h * 4);
        buf.set(raw);
        const phones = new THREE.DataTexture(buf, PHONES_TEX_W, h, THREE.RGBAFormat, THREE.FloatType);
        data(phones);
        phones.needsUpdate = true;
        _assets = { manifest: manifest, off: parts[0], on: parts[1], ids: parts[2], masks: parts[3], masksId: parts[4], stands: parts[5], phones: phones, phoneCount: count, data: parts[7] };
        return _assets;
      });
    })
    .catch(function (err) {
      console.error('[party-mode] stadium assets unavailable, Stadium is withdrawn', err);
      _assets = null;
      return null;
    });
  return _promise.then(function (a) { return !!a; });
}

export function getStadium() {
  return _assets;
}
